import { render, staticRenderFns } from "./kindChooseView.vue?vue&type=template&id=04b1edfe&scoped=true"
import script from "./kindChooseView.vue?vue&type=script&lang=js"
export * from "./kindChooseView.vue?vue&type=script&lang=js"
import style0 from "./kindChooseView.vue?vue&type=style&index=0&id=04b1edfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1edfe",
  null
  
)

export default component.exports